import i18n from 'i18next';

export const EAccountKind = {
  Processing: 'processing',
  Emission: 'emission',
  Distributor: 'root',
  Customer: 'customer',
  Issuer: 'issuer',
} as const;

export type TAccountKind = (typeof EAccountKind)[keyof typeof EAccountKind];

export const AccountKindToFancy = {
  processing: i18n.t('common.accountKind.type.processing') as string,
  emission: i18n.t('common.accountKind.type.emission') as string,
  root: i18n.t('common.accountKind.type.distributor') as string,
  customer: i18n.t('common.accountKind.type.customer') as string,
  issuer: i18n.t('common.accountKind.type.issuer') as string,
  '': '',
};

export type TBranch = {
  guid?: string;
  name?: string;
}

export type TAccountEntity = {
  account_kind: TAccountKind;
  counterparty_guid: string;
  created_at: string;
  iban: string;
  stellar_address: string;
  updated_at: string;
  wallet_account_guid: string;
  wallet_user_external_id: string;
  wallet_user_guid: string;
  branch: TBranch;
};

export type TAccountsListReqParams = {
  wallet_account_guids?: string[];
  wallet_user_guids?: string[];
  account_kinds?: string[];
  iban?: string;
  search_string?: string;
  offset?: number;
  limit?: number;
  order?: string;
};

export type TAdminAccountsReqParams = {
  counterparty_guid?: string;
  branch_guid?: string;
  search_string?: string;
  account_kinds?: string;
  offset?: number;
  order?: string;
  limit?: number;
};

export type TAccountsListResData = {
  accounts: TAccountEntity[] | null;
  total: number;
};

export type TAccountDetailAsset = {
  activated: boolean;
  balance: number;
  code: string;
  minor_unit: number;
  name: string;
  platform: string;
  stellar_code: string;
  stellar_issuer: string;
};

export type TAccountDetailRes = {
  activated: boolean;
  assets: TAccountDetailAsset[];
  assets_total: 0;
  blocked: boolean;
  guid: string;
  name: string;
  platform: string;
  registered: boolean;
  type: string;
  iban: string;
};

export type TCreateAccountReqParams = {
  account_kind: string;
  branch_guid?: string;
  iban?: string;
  key_keeper_login: string;
};

export type TCreateCustomerAccountReqParams = {
  offset?: number;
  order?: string;
  limit?: number;
};

export type TCreateCustomerAccountReqData = {
  counterparty_guid: string;
  customer_guid: string;
  // TODO: need add then API for Edit Account be ready
  // currency?: string;
  // reserve_account?: string;
};

export type TCreateCustomerAccountResData = {
  wallet_account_guid: string;
};

export type CreateAccountResData = {
  wallet_guid: string;
};

export type TCreateBranchAccountReqParams = {
  account_kind: string;
  branch_guid?: string;
  iban?: string;
  key_keeper_login: string;
};

export type TCreateBranchAccountResData = {
  guid: string;
};

export type TAccountCustomerAssetsEntity = {
  activated: boolean;
  balance: number;
  code: string;
  minor_unit: number;
  name: string;
  platform: string;
  stellar_code: string;
  stellar_issuer: string;
};

export type TCustomerAccountEntity = TAccountEntity & {
  activated: boolean;
  assets: TAccountCustomerAssetsEntity[];
  assets_total: number;
  blocked: boolean;
  guid: string;
  name: string;
  platform: string;
  registered: boolean;
  type: string;
  iban?: string;
};

export type TAccountCustomersResData = {
  accounts: TCustomerAccountEntity[];
  total: number;
};
